// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__euCfr","col":"styles_col__1En5V","fulfillmentStatus":"styles_fulfillmentStatus__1joXH","emailCol":"styles_emailCol__OCAHm"};